module.exports = __webpack_public_path__ + "public/img/metamask/nft-placeholder.svg";